import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table for casino report view.
 */
export default class recordTableCasinoReportView extends JetView {
    /**
     * Configures the datatable for displaying casino report data.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Datatable view
            select: true, // Enable row selection
            columns: [
                // Column definitions
                { id: 'Id', header: 'Id', width: 100, sort: 'int' }, // ID column
                {
                    id: 'TransactionId',
                    header: 'Transacción ID', // Transaction ID column
                    width: 100,
                    sort: 'int',
                },
                { id: 'Type', header: 'Tipo', width: 100, sort: 'int' }, // Type column
                {
                    id: 'Amount',
                    header: 'Valor', // Amount column
                    width: 100,
                    format: webix.i18n.priceFormat, // Formatting for price
                    exportType: 'number', // Export type for amount
                    sort: 'int',
                },
            ],
            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
            pager: 'pagerA', // Pager configuration
            // API endpoint for fetching report data
            url: devConfig.geturlApi() + 'null/Report/GetCasinoGamesReportDetail',
        };
    }

    /**
     * Initializes event listeners for filtering and user ID loading.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        // Event listener for filtering the casino report
        this.on(this.app, 'casinoReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'MaxCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add MaxCreatedLocal to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'MinCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add MinCreatedLocal to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log(string1); // Log the constructed query string
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + string1, // Load data with filters applied
            );
        });
        // Event listener for loading data by user ID
        this.on(this.app, 'user:id', (idUser) => {
            grid.load(grid.data.url + '?id=' + idUser); // Load data for specific user
        });
    }
}

// FILE DOCUMENTED
